import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Indicador de carregamento padrão do sistema.
 *
 * - `inline` (padrão): ocupa o lugar do conteúdo que ainda não chegou.
 * - `sobreposicao`: véu translúcido sobre a área que está carregando.
 *   O elemento pai precisa ter `position: relative` (classe PrimeFlex `relative`).
 */
@Component({
  selector: 'app-carregando',
  standalone: true,
  templateUrl: './carregando.component.html',
  styleUrls: ['./carregando.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarregandoComponent {
  @Input() mensagem = 'Carregando...';
  @Input() modo: 'inline' | 'sobreposicao' = 'inline';
}
